/* Oricle supplement buy panel: the pack selector and the purchase type drive the one product form.
   A pack is a quantity (with an optional variant); the plan offered is the one whose cadence
   matches the pack — one bottle a month, three bottles every three months — and a pack with no
   matching plan is one-time only. `selling_plan` is posted only when the plan row is chosen. The
   sticky dock's price mirrors the selected pack. Without JavaScript the form posts one bottle. */
(() => {
  const money = (cents, format) => {
    const n = (Math.round(cents) / 100).toFixed(2).replace(/\.00$/, '');
    const withCommas = n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, withCommas);
  };

  class OriclePackForm extends HTMLElement {
    connectedCallback() {
      if (this._bound) return; this._bound = true;
      this.form = this.querySelector('form');
      this.qtyInput = this.querySelector('[data-o-pack-qty]');
      this.idInput = this.querySelector('[data-o-variant-id]');
      this.planInput = this.querySelector('[data-o-plan-input]');
      this.packs = Array.from(this.querySelectorAll('[data-o-pack]'));
      this.once = this.querySelector('[data-o-ptype-once]');
      this.sub = this.querySelector('[data-o-ptype-sub]');
      this.subWrap = this.querySelector('[data-o-ptype-sub-wrap]');
      this.note = this.querySelector('[data-o-ptype-note]');
      this.cadence = this.querySelector('[data-o-cadence]');
      this.subName = this.querySelector('[data-o-sub-name]');
      this.subPrice = this.querySelector('[data-o-sub-price]');
      this.oncePrice = this.querySelector('[data-o-once-price]');
      this.format = this.dataset.moneyFormat || '${{amount}}';
      this.unitPrice = parseInt(this.dataset.unitPrice, 10) || 0;
      this.defaultVariant = this.idInput ? this.idInput.value : '';
      try { this.plans = JSON.parse((this.querySelector('[data-o-plans]') || {}).textContent || '[]'); } catch (e) { this.plans = []; }
      this.addEventListener('change', (e) => {
        if (e.target.closest('[data-o-pack]')) this.syncPack();
        else if (e.target.closest('[data-o-ptype-once],[data-o-ptype-sub]')) this.syncPlan();
      });
      this.syncPack();
    }
    get pack() {
      const on = this.packs.find((p) => p.checked) || this.packs[0];
      if (!on) return { qty: 1, total: this.unitPrice, months: 1, variant: '' };
      const qty = parseInt(on.dataset.quantity, 10) || 1;
      const total = parseInt(on.dataset.total, 10) || this.unitPrice * qty;
      const months = parseInt(on.dataset.months, 10) || qty;
      return { qty, total, months, variant: on.dataset.variant || '' };
    }
    planFor(months) { return this.plans.find((p) => p.months === months) || null; }
    syncPack() {
      const p = this.pack;
      this.packs.forEach((r) => r.closest('[data-o-pack-tile]') && r.closest('[data-o-pack-tile]').classList.toggle('is-on', r.checked));
      if (this.qtyInput) this.qtyInput.value = p.variant ? 1 : p.qty;
      if (this.idInput) this.idInput.value = p.variant || this.defaultVariant;
      const plan = this.planFor(p.months);
      if (this.oncePrice) this.oncePrice.textContent = money(p.total, this.format);
      if (plan) {
        const subTotal = plan.percent ? p.total * (1 - plan.percent / 100) : (plan.unitPrice ? plan.unitPrice * p.qty : p.total);
        if (this.subWrap) this.subWrap.hidden = false;
        if (this.subName && this.subName.dataset.template) this.subName.textContent = this.subName.dataset.template.replace('{percent}', plan.percent || 0);
        if (this.cadence) this.cadence.textContent = (p.months === 1 ? this.dataset.cadenceOne : (this.dataset.cadenceMany || '').replace('{n}', p.months)) || plan.name;
        if (this.subPrice) this.subPrice.textContent = (this.dataset.perDelivery || '{price}').replace('{price}', money(subTotal, this.format));
        if (this.note) this.note.hidden = true;
      } else {
        if (this.sub && this.sub.checked && this.once) this.once.checked = true;
        if (this.subWrap) this.subWrap.hidden = true;
        if (this.note) this.note.hidden = false;
      }
      this.syncPlan(plan);
      // Every price on the page that mirrors the buy box (the dock) shows the selected pack.
      const scope = this.closest('.o-fold-section') || document;
      scope.querySelectorAll('[data-o-price]').forEach((el) => { el.textContent = money(p.total, this.format); });
      const unit = this.querySelector('[data-o-price-unit]');
      if (unit) unit.textContent = p.qty === 1 ? (unit.dataset.one || '') : (unit.dataset.many || '').replace('{n}', p.qty);
      const per = this.querySelector('[data-o-per-bottle]');
      if (per) { per.hidden = p.qty === 1; per.textContent = (per.dataset.template || '{price}').replace('{price}', money(p.total / p.qty, this.format)); }
    }
    syncPlan(plan) {
      if (plan === undefined) plan = this.planFor(this.pack.months);
      const subscribe = !!(plan && this.sub && this.sub.checked);
      [this.once, this.sub].forEach((r) => r && r.closest('[data-o-ptype-tile]') && r.closest('[data-o-ptype-tile]').classList.toggle('is-on', r.checked));
      if (this.planInput) {
        this.planInput.disabled = !subscribe;
        this.planInput.value = subscribe ? plan.id : '';
      }
    }
  }
  if (!customElements.get('oricle-pack-form')) customElements.define('oricle-pack-form', OriclePackForm);
})();
